import { useCallback } from 'react'
import { useAct } from 'FlowTaker/store'
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from '@stripe/react-stripe-js';
import PaypalButton from './PaypalButton'
import useLanguage from 'FlowBuilder/hooks/useLanguageFlow';

export default function CheckoutPage({ amountInMinorUnits, onComplete, isMonthly, coverFee, currency, stripePromise, handleBack }) {
    const act = useAct()
    const stripeSessionId = useRef(null)
    const language = useLanguage()

    const fetchClientSecret = useCallback(() => {
      return act.taker.createStripeCheckoutSession({ amountInMinorUnits, isMonthly, coverFee, currency, locale: language })
        .then(({ data }) => {
          stripeSessionId.current = data.sessionId

          return data.clientSecret
        })
    }, []);

    const options = { fetchClientSecret, onComplete: v => onComplete({ stripeSessionId: stripeSessionId.current }) };

    return (
      <div id="checkout">
        {handleBack && (
          <div className="back-link margin-bottom">
            <a href="#" onClick={(e) => { e.preventDefault(); handleBack(); }}>
              <SvgIconsArrowLeft variant="light" />
              <span>Back</span>
            </a>
          </div>
        )}
        <div className='margin-bottom'>
          <PaypalButton amountInMinorUnits={amountInMinorUnits} currency={currency} isMonthly={isMonthly} coverFee={coverFee} onComplete={onComplete} stripePromise={stripePromise} />
        </div>
        <EmbeddedCheckoutProvider
          stripe={stripePromise}
          options={options}
        >
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </div>
    )
  }
